import React from 'react';
import { MapPin, ChevronDown } from 'lucide-react';
export function LeftSidebar() {
  const navItems = ['Local News', 'Headlines', 'Posts', 'Newsletter', 'Topics', 'Reactions'];
  const footerLinks = ['About Us', 'Careers', 'Help Center', 'Contact', 'Blog'];
  return <aside className="hidden lg:flex flex-col h-screen sticky top-0 overflow-y-auto py-6 px-4 border-r border-gray-100" data-id="element-133">
      {/* Logo */}
      <div className="mb-8" data-id="element-134">
        <div className="flex items-center gap-2 font-bold text-xl tracking-tight text-gray-900" data-id="element-135">
          <div className="relative w-8 h-8" data-id="element-136">
            <div className="absolute inset-0 bg-red-500 transform skew-x-12 rounded-sm" data-id="element-137"></div>
            <span className="absolute inset-0 flex items-center justify-center text-white font-black italic text-lg" data-id="element-138">
              N
            </span>
          </div>
          NEWSBREAK
        </div>
      </div>

      {/* Location Selector */}
      <div className="mb-8" data-id="element-139">
        <div className="flex items-start justify-between group cursor-pointer" data-id="element-140">
          <div data-id="element-141">
            <h2 className="text-xl font-bold text-gray-900 leading-tight mb-1" data-id="element-142">
              Choose your
              <br data-id="element-143" />
              location
            </h2>
          </div>
          <ChevronDown className="w-5 h-5 text-gray-500 mt-1" data-id="element-144" />
        </div>
        <div className="mt-2 space-y-1" data-id="element-145">
          <a href="#" className="block text-sm text-gray-500 hover:text-blue-600 underline decoration-gray-300" data-id="element-146">
            See all locations
          </a>
          <div className="flex items-center gap-1 text-sm text-blue-600 cursor-pointer hover:underline" data-id="element-147">
            <span data-id="element-148">Customize your news</span>
            <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-149"></span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="space-y-1 mb-8" data-id="element-150">
        {navItems.map(item => <a key={item} href="#" className="block py-2 text-gray-700 hover:text-red-500 hover:bg-gray-50 rounded-md transition-colors font-medium" data-id="element-151">
            {item}
          </a>)}
      </nav>

      {/* Sign In Button */}
      <div className="mb-10" data-id="element-152">
        <button className="w-full bg-gray-900 hover:bg-gray-800 text-white font-medium py-2.5 px-4 rounded-full transition-colors shadow-sm" data-id="element-153">
          Sign In
        </button>
      </div>

      {/* Footer Links */}
      <div className="mt-auto" data-id="element-154">
        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3" data-id="element-155">
          About NewsBreak
        </h3>
        <ul className="space-y-2" data-id="element-156">
          {footerLinks.map(link => <li key={link} data-id="element-157">
              <a href="#" className="text-xs text-gray-500 hover:text-gray-900 block" data-id="element-158">
                {link}
              </a>
            </li>)}
        </ul>
      </div>
    </aside>;
}